module.exports = __webpack_public_path__ + "static/media/smallDeliveryTruck_pink.a89c496d.svg";